import RestResource from '../rest.service';
import Service from '../api.service';

export default class LiquidationService extends RestResource {
  mapInvoice(payload) {
    let formData = new FormData();
    formData.append('invoice', payload.invoice);
    formData.append('invoice_number', payload.invoiceNumber);
    formData.append('description', payload.description);
    formData.append('liquidation_id', payload.liquidationId);

    return formData;
  }

  map(payload) {
    return {
      liquidationable_type: payload.liquidationableType,
      liquidationable_id: payload.liquidationableId,
      amount: payload.amount,
      order_ids: payload.orderIds,
    };
  }

  byMonths(params = {}) {
    return Service.get(`${this.getResource()}/by-months`, { params }).catch(this.handleErrors);
  }

  byItemsPdf(params, filename) {
    return Service.get(`${this.resource}/pdf`, { params, responseType: 'arraybuffer' })
      .then((res) => this.downloadPDF(res, filename))
      .catch(this.handleErrors);
  }

  addInvoice(payload, headers) {
    return Service.post(`${this.getResource()}/add-invoice?${headers}`, this.mapInvoice(payload));
  }

  constructor() {
    super('liquidations');
  }
}
